import styled from"@emotion/styled";import{mediaQuery}from"@wp/src/components/common/grid";import{Divider}from"antd";import{zip}from"ramda";import{ArrowBar,ArrowContainer,LeftArrow,RightArrow}from"./scoreImpactAtoms";export const SubScoreImpactContainer=styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;export const SubScoreIndicatorRow=styled.div`
  width: 100%;
  min-height: 16px;
  position: relative;

  > div {
    position: absolute;
  }
`;export const SubScoreValuesPlotRow=styled(SubScoreIndicatorRow)``;export const ScoreScale=styled(Divider)`
  margin: 6px 0;
  opacity: 0.1;
  border: 0.5px solid ${props=>props.theme.colors.black};
`;export const SubScoreArrowContainer=styled(ArrowContainer)`
  width: 100%;
`;export const SubScoreArrowBar=styled(ArrowBar)`
  flex-shrink: 0;
`;export const SubScoreRightArrow=styled(RightArrow)`
  flex-shrink: 0;
  font-size: 14px;
`;export const SubScoreLeftArrow=styled(LeftArrow)`
  flex-shrink: 0;
  font-size: 14px;
`;export const SubScoreArrowStartPoint=styled.div`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: ${props=>props.theme.colors.neutral600};
  margin-top: 3px;
`;export const SubScoreIndicatorContainer=styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: 30px;
  position: relative;
`;const scoreFontSizes=[12,12,14];const additionalPixelOffsets=[4,4,5];export const pointScorePixelOffsets=scoreFontSizes.map(fontSize=>fontSize/2);export const arrowScorePixelOffsets=zip(pointScorePixelOffsets,additionalPixelOffsets).map(([pointScorePixelOffset,additionalPixelOffset])=>pointScorePixelOffset+additionalPixelOffset);const subScoreValueFontSizes=scoreFontSizes.map(score=>`${score}px`);export const SubScoreValue=styled.span`
  font-style: normal;
  font-weight: 600;
  position: absolute;

  ${mediaQuery({fontSize:subScoreValueFontSizes})}
`;export const SubScoreLabel=styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${props=>props.theme.colors.black};
  flex-basis: 12rem;
  align-self: flex-end;
`;